export default __webpack_public_path__ + "static/media/Snd_o1.9eca09e4.mp3";